import { render } from "./ChatWidget.vue?vue&type=template&id=23ce91b3&scoped=true"
import script from "./ChatWidget.js?vue&type=script&lang=js&external"
export * from "./ChatWidget.js?vue&type=script&lang=js&external"

import "./ChatWidget.css?vue&type=style&index=0&id=23ce91b3&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ce91b3"]])

export default __exports__